import templateUrl from './reset.component.html';

export const ResetComponent = {
    templateUrl,
    controller: ResetController,
    controllerAs: "vm",
};

function ResetController(onboardingDocumentService, utilityService, employeeService) {
    'ngInject';
    const vm = this;

    vm.$onInit = function () {

    }

}
